export const TEST_MODE_LOCAL_STORAGE_KEY = 'TEST_MODE';
export const getIsTestMode = ()=>!!localStorage.getItem(TEST_MODE_LOCAL_STORAGE_KEY);
export const isTestMode = getIsTestMode();
